import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PRM } from '@reflact/prmacweb';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../auth/auth.service';
import { SocketService } from '../../shared/SocketService';
import { LayoutDirective } from '../../shared/services/layout.directive';
import { LayoutService } from '../../shared/services/layout.service';
import { VideoService } from '../../shared/video/video.service';
import { UserImageAndNameDisplayComponent } from '../observer-conference/user-image-and-name-display/user-image-and-name-display.component';

@Component({
  selector: 'app-video-share',
  templateUrl: './video-share.component.html',
  styleUrls: ['./video-share.component.css'],
  imports: [
    CommonModule,
    UserImageAndNameDisplayComponent,
    LayoutDirective,
    FormsModule
  ],
  standalone: true
})
export class VideoShareComponent implements OnInit, OnDestroy {
  public pack: PRM.IpadPackage;
  public feedbackForVideos: any[] = [];
  public dayjs;

  constructor(public layoutService: LayoutService,
    public authService: AuthService,
    public videoService: VideoService,
    private aRoute: ActivatedRoute, private socketService: SocketService, private toastr: ToastrService
  ) {
    dayjs.extend(relativeTime);
    this.dayjs = dayjs;
    this.socketService.socket.on('feedbackParticipant', this.feedbackParticipantRecieved.bind(this));
  }

  public ngOnInit() {
    this.fetchFeedbackVideos();
  }

  public ngOnDestroy(): void {
    this.feedbackForVideos?.forEach(video => this.videoService.releaseVideoUrl(video.videoUrl));
  }

  async fetchFeedbackVideos() {
    const allFeedbackVideos: any = await this.videoService.getAllFeedbackVideos();

    console.log("fetch feedabck videos", allFeedbackVideos)

    try {
      if (allFeedbackVideos) {
        this.feedbackForVideos = await Promise.all(allFeedbackVideos.feedbacks.map(async (video) => ({
          ...video,
          videoUrl: await this.videoService.playVideo(video._id)
        })));
      }
    } catch (error) {
      console.error('Unable to load feedback video', error);
      this.toastr.error($localize`:@@videoLoadFailed:Das Video konnte nicht geladen werden.`);
      return;
    }
    this.aRoute.data.subscribe((data) => {
      this.pack = data.pack;
      this.feedbackForVideos.forEach((vid) => {
        vid.participantObject = this.getParticipantObject(vid.metadata.participantid);
      });
    });
  }

  private async feedbackParticipantRecieved(data: any) {
    if (!data.inviting) {
      this.removeFeedbackVideo(data.video);
      return;
    }
    const video = data.video;
    video.ratingComment = undefined;
    video.participantObject = this.getParticipantObject(video.metadata.participantid);
    try {
      video.videoUrl = await this.videoService.playVideo(video._id);
      this.feedbackForVideos.push(video);
    } catch (error) {
      console.error('Unable to load feedback video', error);
      this.toastr.error($localize`:@@videoLoadFailed:Das Video konnte nicht geladen werden.`);
    }
  }

  private getParticipantObject(participantId: string) {
    const index = this.pack.allparticipants.findIndex(p => p.id === participantId);
    if (index > -1) {
      return this.pack.allparticipants[index];
    }
  }

  private removeFeedbackVideo(video: PRM.ParticipantVideo) {
    const index = this.feedbackForVideos.findIndex(f => f._id === video._id);
    if (index > -1) {
      this.videoService.releaseVideoUrl(this.feedbackForVideos[index].videoUrl);
      this.feedbackForVideos.splice(index, 1);
    }
  }

  public saveRating(feedbackVid: any) {
    feedbackVid.check = true;
    this.videoService.saveRatingForVideoId(feedbackVid._id, feedbackVid.myfeedback, feedbackVid.ratingComment);
    setTimeout(() => { feedbackVid.check = false; }, 1000);
  }
}